export const isResponseStatusSuccess = (responseStatus) => responseStatus !== undefined && responseStatus >= 200 && responseStatus < 300;
export const getResponseData = async (response, mapper) => {
    if (!isResponseStatusSuccess(response?.status)) {
        return {
            status: ApiStatus.Failed,
            errorText: response?.statusText ?? 'Unknown error',
        };
    }
    const data = response.data;
    return { data: mapper ? mapper(data) : data, status: ApiStatus.Loaded };
};
export var ApiStatus;
(function (ApiStatus) {
    ApiStatus[ApiStatus["Unknown"] = 0] = "Unknown";
    ApiStatus[ApiStatus["Loading"] = 1] = "Loading";
    ApiStatus[ApiStatus["Loaded"] = 2] = "Loaded";
    ApiStatus[ApiStatus["Failed"] = 3] = "Failed";
})(ApiStatus || (ApiStatus = {}));
